import { IPath } from "../ahamove/UrlRequestParam"
import { IProduct } from "../wms/IProduct"

export interface IAction {
  is_sending: boolean
  is_loading_fee: boolean
  can_estimate_fee: boolean
}
// tuỳ biến theo ahamove
export interface IOrders {
  remarks?: string
  date?: string
  time?: string
  is_order_now?: boolean
  service_id?: string
  path: IPath[]
  items?: IProduct[]
  payment_method?: string
  type?: string
  // event
  action: IAction
}
export class Orders {
  Form: IOrders
  Items: IProduct[]
  constructor(_form: IOrders) {
    this.Form = _form
    this.Items = _form.items ?? []
  }
  orderTime(): number {
    if (!this.Form.date || !this.Form.time) return 0
    let datetimeCombine = new Date(`${this.Form.date} ${this.Form.time}`).getTime() / 1000
    return datetimeCombine
  }
}